// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"161":"5b3c7c67","559":"38738fc5"}[chunkId] + ".chunk.css";
};